import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { normalize } from 'normalizr';
import { selectLocale } from 'models/localization';
import fetchBoothTiersRequest, {
  FetchBoothTiersQueryProps,
} from 'network/fetchBoothTiers';
import { boothTiersAdapter, selectAllBoothTiers } from './selectors';
import { boothTierEntity, BoothTier } from './types';
import { fetchCachedCMSData } from '../common/thunks';

export const fetchBoothTiers = createAsyncThunk(
  'boothTiers/fetchBoothTiers',
  async (config: FetchBoothTiersQueryProps = {}, { getState }) => {
    try {
      const state = getState();
      const locale = selectLocale(state);
      const tiers = selectAllBoothTiers(state);
      const { boothTiers } = await fetchBoothTiersRequest({ locales: [locale], ...config });
      const { entities } = normalize<BoothTier>([...tiers, ...boothTiers], [boothTierEntity]);
      return entities.boothTiers;
    } catch (error) {
      console.error(error);
    }
    return {};
  },
  {
    condition(_, { getState }) {
      const state = getState();
      const locale = selectLocale(state);
      const tiers = selectAllBoothTiers(state);
      return !Object.keys(tiers?.[0]?.name || {}).includes(locale);
    },
  },
);

export const boothTiersSlice = createSlice({
  name: 'boothTiers',
  initialState: boothTiersAdapter.getInitialState({
    fetching: true,
  }),
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchCachedCMSData.rejected, (state) => {
      if (state.fetching) state.fetching = false;
    });
    builder.addCase(fetchCachedCMSData.fulfilled, (state, action) => {
      state.fetching = false;
      const { boothTiers } = action.payload;
      if (boothTiers && Object.keys(boothTiers).length) {
        boothTiersAdapter.upsertMany(state, boothTiers);
      }
    });

    builder.addCase(fetchBoothTiers.pending, (state) => {
      state.fetching = true;
    });
    builder.addCase(fetchBoothTiers.rejected, (state) => {
      if (state.fetching) state.fetching = false;
    });
    builder.addCase(fetchBoothTiers.fulfilled, (state, action) => {
      state.fetching = false;
      if (action.payload && Object.keys(action.payload).length) {
        boothTiersAdapter.upsertMany(state, action.payload);
      }
    });
  },
});

export default boothTiersSlice.reducer;
